import React, { Fragment, useState } from 'react'
import { TenantProviderOverView } from './partials/TenantProviderOverView'
import { numberToPrice } from '../utils'
import './styles.scss'

export const TenantYearOverview = ({ entry, total }) => {
  const currentYear = new Date().getFullYear()
  const { bookingsDetails, year } = entry
  const [isExpanded, setIsExpanded] = useState(currentYear <= year)
  const toggle = () => setIsExpanded(!isExpanded)
  return (
    <Fragment>
      <h3 className="tenant-year-overview__headline" onClick={toggle}>
        <span>{year}</span>
        <span className="tenant-year-overview__costs-label">
          {numberToPrice('Cannot be calculated')(total)}
        </span>
      </h3>
      {isExpanded && (
        <div>
          {bookingsDetails.map((item) => (
            <TenantProviderOverView
              data={item.bookings}
              provider={item.providerName}
              totalPrice={item.totalPrice}
              key={item.providerSlug}
            />
          ))}
        </div>
      )}
    </Fragment>
  )
}
